"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgRiskLevelUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 96,
    viewBox: "0 0 80 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.727 96S80 77.406 80 48.962V18.005L40 0 0 18.005v30.957l.008.703C.61 77.838 39.728 96 39.728 96zM6.093 49.565c.256 11.289 8.348 21.344 17.855 29.122 4.612 3.773 9.237 6.745 12.723 8.777a96.27 96.27 0 003.066 1.715 99.017 99.017 0 003.232-1.795c3.585-2.077 8.334-5.111 13.05-8.954 9.748-7.943 17.895-18.132 17.895-29.468V21.939L40 6.674 6.086 21.94v26.99l.007.636z",
    fill: "url(#riskLevelUp_svg__riskLevelUp_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.121 35.364L26.243 46.243 22 42l18-18 18.121 18.121L54 46.243 43.121 35.364v31.757h-6V35.364z",
    fill: "url(#riskLevelUp_svg__riskLevelUp_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "riskLevelUp_svg__riskLevelUp_svg__paint0_linear",
    x1: 100.071,
    y1: 53.09,
    x2: 34.301,
    y2: -15.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: props.color || "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: props.color || "#fff",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "riskLevelUp_svg__riskLevelUp_svg__paint1_linear",
    x1: 31.449,
    y1: 11.416,
    x2: 8.769,
    y2: 52.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: props.color || "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: props.color || "#fff",
    stopOpacity: 0.5
  }))));
}

var _default = SvgRiskLevelUp;
exports["default"] = _default;